import React, { useRef, useState, useEffect } from 'react';
import Navbar from './Navbar';
import "./cotact.css"
import emailjs from 'emailjs-com';
import PulseLoader from "react-spinners/PulseLoader";
import BounceLoader from "react-spinners/BounceLoader";
import { gsap } from "gsap";
import Footer from './Footer';

const Contact = () => {

    const mainRef = useRef();
    const [nameValue, setnameValue] = useState();
    const [emailValue, setemailValue] = useState();
    const [PhnValue, setPhnValue] = useState();
    const [MsgValue, setMsgValue] = useState();
    const [showSendLoader, setshowSendLoader] = useState(false);
    const [showalert, setshowalert] = useState(false);
    const [alertMsg, setalertMsg] = useState();
    const [isSuccess, setisSuccess] = useState(false);
    const wheelRef = useRef();


    useEffect(() => {
        document.title = "Contact"
    }, [])

    const el = useRef();
    const q = gsap.utils.selector(el);

    function sendEmail(e) {
        e.preventDefault();
        setnameValue('')
        setemailValue('')
        setPhnValue('')
        setMsgValue('')
        setshowSendLoader(true)

        emailjs.sendForm('service_ex2i0wn', 'template_0i7xmfl', e.target, 'user_h1ep2TaZXvmwLGLN71p9H')
            .then((result) => {
                setshowSendLoader(false)
                setshowalert(true)
                setisSuccess(true)
                setalertMsg("Your message has sent successfully, Thanks.")
            }, (error) => {
                setshowSendLoader(false)
                setshowalert(true)
                setisSuccess(false)
                setalertMsg(`oops, message sending failed: ${error}`)
            });
    }

    const handeChange = (e) => {
        setnameValue(e.target.value)
    }
    const handeEmailChange = (e) => {
        setemailValue(e.target.value)
    }
    const handePhnChange = (e) => {
        setPhnValue(e.target.value)
    }
    const handeMsgChange = (e) => {
        setMsgValue(e.target.value)
    }

    const [hideLoader, setHideLoader] = useState(false)

    useEffect(() => {
        // document.body.onload = () => {0
        //     setHideLoader(true)
        // }

        setTimeout(() => {

            setHideLoader(true)
        }, 300)

    }, [])


    var mobileScreen = window.matchMedia("(max-width: 800px)");

    useEffect(() => {

        if (mobileScreen.matches) {
            const t5 = gsap.timeline()

            t5
                .from(q(".addDetailside"), {
                    opacity: 0,
                    y: 50,
                    duration: 0.7
                }, 1)
                .from(q(".formside"), {
                    opacity: 0,
                    y: -50,
                    duration: 0.7
                }, 1)
        }
        else {
            const t5 = gsap.timeline()

            t5
                .from(q(".addDetailside"), {
                    opacity: 0,
                    x: 100,
                    duration: 0.7
                }, 1)
                .from(q(".formside"), {
                    opacity: 0,
                    x: -100,
                    duration: 0.7
                }, 1)
        }



    }, []);


    useEffect(() => {

        window.onscroll = function () {
            wheelRef.current.style.transform = "rotate(" + window.pageYOffset / 2 + "deg)";
        };
    }, [])

    return (
        <>
            <div className="preloader" style={{ width: "100%", height: "100vh", background: "black", position: "fixed", top: "0", zIndex: "9999999", opacity: hideLoader && 0, visibility: hideLoader && "hidden", transition: "all 0.5s ease-in-out", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <BounceLoader color="#ff792e" size={100} />
            </div>
            <div ref={mainRef} className="mainCover" style={{ opacity: hideLoader && 1, transition: "all 0.5s ease-in-out" }}>
                <div className="alert" style={{ opacity: showalert && 1, visibility: showalert && "visible", background: isSuccess && "#D1E7DD", color: isSuccess && "#0F517F" }}>
                    <h2>{alertMsg}</h2>
                    <i className="fas fa-times" onClick={() => setshowalert(false)}></i>
                </div>
                <Navbar workRef={mainRef} textcolor="rgb(252, 246, 244)" />

                <section ref={el} className="contact">
                    <div className="containerWrapper">
                        <div className="contactContainer">
                            <div className="addDetailside">
                                <div className='detailwrapper'>
                                    <div className="contactHeading">
                                        <h1>Contact Us</h1>
                                        <div className="underline">
                                            <span className="circle"></span>
                                            <span className="line"></span>
                                        </div>
                                    </div>
                                    <div className="addDetails">
                                        <ul>
                                            <li><i className="fas fa-phone-alt"></i>9779725255</li>
                                            <li><i className="fas fa-envelope"></i>apardeepsingh2244@gmail.com</li>
                                            <li><i className="fas fa-map-marker-alt"></i>Punjab, India</li>
                                        </ul>
                                    </div>
                                    <div className="otherWays">
                                        <div className="otherWaysHeading">
                                            <h1>Other Ways</h1>
                                            <div className="underline">
                                                <span className="circle"></span>
                                                <span className="line"></span>
                                            </div>
                                        </div>
                                        <ul>
                                            <li><a href="https://www.instagram.com/apardeep_singh_2000/" target="_blank"><i className="fab fa-instagram" /></a></li>
                                            <li><a href="https://www.facebook.com/apardeepsingh" target="_blank"><i className="fab fa-facebook" /></a></li>
                                            <li><a href="https://api.whatsapp.com/send/?phone=919779725255&text&app_absent=0" target="_blank"><i className="fab fa-whatsapp" /></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="formside">
                                <div className="getintouchHeading">
                                    <h1>Get in touch</h1>
                                    <div className="underline">
                                        <span className="circle"></span>
                                        <span className="line"></span>
                                    </div>
                                </div>
                                <form onSubmit={sendEmail}>
                                    <span className='inputWrapper'>
                                        <input onChange={handeChange} value={nameValue} type="text" name='name' required />
                                        <label htmlFor="Name">Your Name</label>
                                    </span>
                                    <span className='inputWrapper'>
                                        <input onChange={handeEmailChange} value={emailValue} type="email" name='user_email' required />
                                        <label htmlFor="Name">Your email</label>
                                    </span>
                                    <span className='inputWrapper'>
                                        <input onChange={handePhnChange} value={PhnValue} type="tel" name='user_phn' required />
                                        <label htmlFor="Name">Your moblie number</label>
                                    </span>
                                    <span className='inputWrapper'>
                                        <textarea onChange={handeMsgChange} value={MsgValue} name="message" rows="3" required />
                                        <label htmlFor="Name">Type your message here...</label>
                                    </span>
                                    {/* <input type="submit" value="Send message" /> */}
                                    <span className='inputWrapper'>
                                        <button type='submit' className='submitBtn' style={{ opacity: showSendLoader && 0, visibility: showSendLoader && "hidden" }} >
                                            <span className="btnBG"></span>
                                            <p>Send message</p>
                                        </button>
                                        <span className="sendloader" style={{ opacity: showSendLoader && 1, visibility: showSendLoader && "visible" }}>
                                            {/* <FadeLoader color="#ff792e" width={2.3} height={9} margin={-4} radius={2} /> */}
                                            <PulseLoader color="#ff792e" />
                                        </span>
                                    </span>
                                </form>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </section>
                <div className="rotationWheel">
                    <i ref={wheelRef} className="fas fa-yin-yang"></i>
                </div>
            </div>
        </>
    )
}


export default Contact;